import { render } from "./ImageInsert.vue?vue&type=template&id=bc4aa5ac&scoped=true"
import script from "./ImageInsert.vue?vue&type=script&lang=js"
export * from "./ImageInsert.vue?vue&type=script&lang=js"

import "./ImageInsert.vue?vue&type=style&index=0&id=bc4aa5ac&scoped=true&lang=css"
import "./ImageInsert.vue?vue&type=style&index=1&id=bc4aa5ac&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4aa5ac"]])

export default __exports__